/** Operator-facing timestamp: 2026年8月19日 20:38:00 */
export function formatJsonEditWhen(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  return `${year}年${month}月${day}日 ${hh}:${mm}:${ss}`;
}

export function jsonEditKindLabel(kind: string): string {
  if (kind === "added") return "新增";
  if (kind === "removed") return "删除";
  if (kind === "moved") return "移动";
  return "修改";
}
